import { Enum } from "./Enum";

export const ProductSupplierEnum: Enum[] = [
    { id: "NONE", name: "NONE" },
    { id: "MAR", name: "MAR" },
    { id: "BOH", name: "BOH" },
    { id: "GUE", name: "GUE" },
    { id: "ALD", name: "ALD" },
    { id: "CST", name: "CST" },
    { id: "TEX", name: "TEX" },
    { id: "NOU", name: "NOU" },
];